import React from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import PlayersViewComponent from "../home-common-components/PlayersViewComponent";
import { CommonButton } from "../../common/CommonButton";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { AppImages } from "../../utility/AppImages";
import withErrorBoundary from "../../utility/auth/withErrorBoundary";
import Skeletons from "../skeleton-components/Skeletons";

const StreamerViewComponent = ({
  styles,
  setIsShare,
  participants,
  attendees,
  showLoader = false,
}) => {
  const deviceSize = useDeviceSize();
  return (
    <View style={styles.streamViewStyle}>
      {showLoader ? (
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 228
              : 285
          }
          style={{
            borderRadius: 10,
          }}
        />
      ) : (
        <>
          <View
            style={{
              justifyContent: "space-between",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <View
              style={{
                height: 26,
                justifyContent: "flex-start",
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
              }}
            >
              <View
                style={{
                  height: 15,
                  width: 15,
                  aspectRatio: 1,
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  borderRadius: 13,
                }}
              />
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_14,
                  { color: AppColors.white },
                ]}
              >
                Streamer
              </Text>
            </View>
            {deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.SM ? (
              <TouchableOpacity
                onPress={() => {
                  setIsShare(true);
                }}
                style={{}}
              >
                <Image
                  source={AppImages.icshare}
                  style={{ height: 20, width: 20 }}
                />
              </TouchableOpacity>
            ) : null}
          </View>

          <PlayersViewComponent styles={styles} participants={participants} />
          <View
            style={{
              height: 22,
              justifyContent: "flex-start",
              alignSelf: "flex-start",
            }}
          >
            <CommonButton
              title={`${attendees} Attendees`}
              onTap={() => {}}
              buttonStyle={[
                styles.btnGetTicketStyle
                  ? styles.btnGetTicketStyle
                  : styles.btnSignUpStyle,
                {
                  backgroundColor: AppColors.appViolentColor_6D08C3,
                  shadowOpacity: 0,
                  height: 22,
                  borderRadius: 10,
                },
              ]}
              textStyle={[AppFontStyle.REGULAR_ANYBODY_10]}
            />
          </View>
        </>
      )}
    </View>
  );
};

export default withErrorBoundary(StreamerViewComponent);
